import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { loadTranslations } from '@/js/global/vue-i18n'
import type { MapIframeParentWindow } from '@/js/booking/institution-map/window'
import BookingSearch from '@/components/booking/views/BookingSearch.vue'
import router from '@/js/booking/booking-search-router'

const app = createApp(BookingSearch)

loadTranslations(app).then(() => {
    app.use(router)
    app.use(createPinia())

    const bookingVue = app.mount('#booking-search') as InstanceType<typeof BookingSearch>

    const mapHostWindow = window as MapIframeParentWindow

    mapHostWindow.openInstitutionFromMap = institution => {
        bookingVue.openInstitutionFromMap(institution)
    }
})
